function EmphasisText({ children }) {
  return (
    <span className="font-semibold border-b border-yellow-500">{children}</span>
  )
}

export default EmphasisText;